import { Component, OnInit, ViewEncapsulation, Input, ElementRef, ViewChild, AfterViewInit, OnChanges } from '@angular/core';
import * as d3 from "d3";
import { csvParse } from "d3";
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { GlobalVarsService } from 'src/app/service/global-vars.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-prohormone',
  templateUrl: './prohormone.component.html',
  styleUrls: ['./prohormone.component.scss']
})
export class ProhormoneComponent implements OnInit {
 @Input() donorInf: any;
  @ViewChild('myIdentifier')
  myIdentifier: ElementRef;
    subBaseUrl: Subscription;
  baseUrl: string;

 data: any;
  svg: any;
  donorInfType: string;
  base64Image: any;
  imageToShow: any;

csvUrl: string;
  colWidth: number = 250;
  donorID: string;
  measureType: string = 'lg';
  measureOptions: any[] = [{ label: 'Low Glucose(1.67 mM)', value: 'lg' }, { label: 'High Glucose(16.7 mM)', value: 'hg' }, { label: 'Lysate', value: 'lysate' }];
  varCol: string;
  varCol2: string;
  varCol3: string;
  varCol4: string;

constructor(private http: HttpClient, private global: GlobalVarsService, private element: ElementRef, private domSanitizer: DomSanitizer) {
    this.donorInfType = typeof this.donorInf;
  }

  ngOnInit(): void {
 this.subBaseUrl = this.global.baseUrl.subscribe(data => {
      this.baseUrl = data
      this.csvUrl = this.baseUrl + "download/humanislets/display_data-numerical_prohormone.csv"; 
    })
 if (typeof this.csvUrl !== 'undefined') {
  setTimeout(() => {
    this.main();
  }, 1500); 
    }
  }

  ngAfterViewInit(): void {
    this.colWidth = this.myIdentifier.nativeElement.offsetWidth - 50; // determine plot width based on grid size
  }
   
  ngOnChanges() {

    if (typeof this.csvUrl !== 'undefined') {
      // add text labels
      this.donorInfType = typeof this.donorInf;
      this.donorID = this.donorInf.record_id
      this.main();
    }
  }
  main() {
    // make plots
    this.http.get(this.csvUrl, {responseType: 'text' }).subscribe(data => {
      this.data = csvParse(data, d3.autoType);
      console.log(this.donorInf)
 
      this.basicHistogram(this.data, "cp", this.colWidth, 350, 15, "#cpeptideHistogram", 50, "#43a047", this.donorInf[this.measureType].cp.value, this.donorInf[this.measureType].cp.perc)
      this.basicHistogram(this.data, "pi", this.colWidth, 350, 15, "#proinsulinHistogram", 50, "#43a047", this.donorInf[this.measureType].pi.value, this.donorInf[this.measureType].pi.perc)

      this.basicDensity(this.data, "cppiratio", this.colWidth, 200, 15, "#ratio1Histogram", 50, "#cc00ff", this.donorInf[this.measureType].cppiratio.value, this.donorInf[this.measureType].cppiratio.perc, 15)
      this.basicDensity(this.data, "picpratio", this.colWidth, 200, 15, "#ratio2Histogram", 50, "#cc00ff", this.donorInf[this.measureType].picpratio.value, this.donorInf[this.measureType].picpratio.perc, 15)
    })
};


  
  basicHistogram(inputData: any, varName: string, width: number, height: number, binPar: number, selectTerm: string,
    marginBottom: number, color: string, vert: number, perc: number) {

    d3.select(selectTerm).select("svg").remove();
      var varCol = "avg"+this.measureType+varName;
 
    console.log(varCol)
    // remove NA - too many messes up histogram function
    inputData = inputData.filter(d => d[varCol] != 'NA');

    var margin = { top: 0, right: 10, bottom: marginBottom, left: 10 }
    var compHeight = height - margin.bottom - margin.top;

    // set the parameters for the histogram
    const bins = d3.bin()
      .thresholds(binPar)
      .value((d) =>  d[varCol])
      (inputData);
    // Create the x-axis
    const x = d3.scaleLinear()
      .domain([bins[0].x0, bins[bins.length - 1].x1])
      .range([0, width - margin.right - margin.left]);
    // Create the y-axis
    var y = d3.scaleLinear()
      .range([compHeight, 0]);
    y.domain([0, d3.max(bins, function (d) { return d.length; })]);

    // Create SVG
    this.svg = d3.select(this.element.nativeElement)
      .select(selectTerm)
      .append('svg')
      .attr("width", width)
      .attr("height", height)
      .attr("viewBox", [0, 0, width, height])
      .attr("style", "max-width: 100%; height: auto; height: intrinsic;")
      .style("-webkit-tap-highlight-color", "transparent")
      .append("g")
      .attr("transform",
        "translate(" + margin.left + "," + margin.top + ")");
 
    this.svg.append("g")
      .attr("transform", "translate(0," + compHeight + ")")
      .call(d3.axisBottom(x)
       .tickFormat(d3.format("d")) // Format ticks as integers
       )
      .selectAll("text")
      .style("text-anchor", "end")
      .attr("dx", "-.8em")
      .attr("dy", ".15em")
      .attr("transform", "rotate(-65)")
      .call(g => g.select(".domain").remove())

    this.svg.selectAll("rect")
      .data(bins)
      .enter()
      .append("rect")
      .attr("x", 0)
      .attr("transform", function (d) { return "translate(" + x(d.x0) + "," + y(d.length) + ")"; })
      .attr("width", function (d) { return x(d.x1) - x(d.x0); })
      .attr("height", function (d) { return compHeight - y(d.length); })
      .style("fill", color)
      .attr("fill-opacity", "0.6")

    if (!isNaN(vert)) {
      var percText =  Math.round(perc * 100).toString() + "th perc."
      this.svg.append("line")
        .attr("y1", 0)
        .attr("y2", compHeight)
        .attr("x1", x(vert))
        .attr("x2", x(vert))
        .style("stroke-width", 2)
        .style("stroke", "black")
        .style("fill", "none");

      if (x(vert) > (width / 2)) {
        this.svg.append("text")
          .attr("x", x(vert) - 30)
          .attr("y", 15)
          .text(percText)
          .style("font-weight", "bold")
          .style("font-size", "12pt")
      } else {
        this.svg.append("text")
          .attr("x", x(vert) + 5)
          .attr("y", 15)
          .text(percText)
          .style("font-weight", "bold")
          .style("font-size", "12pt")
      }
    }

  }

  basicDensity(inputData: any, varName: string, width: number, height: number, binPar: number, selectTerm: string,
    marginBottom: number, color: string, vert: number, perc: number, resolution: number) {

    d3.select(selectTerm).select("svg").remove();
    var varCol = this.measureType+varName;
  
    // remove NA - too many messes up histogram function
    inputData = inputData.filter(d => d[varCol] != 'NA');

    var margin = { top: 0, right: 10, bottom: marginBottom, left: 10 }
    var compHeight = height - margin.bottom - margin.top;

    // set the parameters for the histogram
    const bins = d3.bin()
      .thresholds(binPar)
      .value((d) => d[varCol])
      (inputData);

    var xExtent = d3.extent(d3.map(inputData, d => d[varCol]))
    var xMag = xExtent[1] - xExtent[0]

    // Create the x-axis
    const x = d3.scaleSqrt()
      .domain([(xExtent[0] - 0.2 * xMag), (xExtent[1] + 0.2 * xMag)]) // need to be a bit larger than extent because density profiles extend past
      .range([0, width - margin.right - margin.left]);

    // Compute kernel density estimation
    var kde = this.kernelDensityEstimator(this.kernelEpanechnikov(xMag/resolution), x.ticks(100))
    var density = kde(inputData.map(function (d) { return d[varCol]; }))

    var densityMax = d3.max(density, function(d) { return d[1]}) as unknown as number;

    // Create the y-axis
    var y = d3.scaleLinear()
      .range([compHeight, 0])
      .domain([0, densityMax]);

    // Create SVG
    this.svg = d3.select(this.element.nativeElement)
      .select(selectTerm)
      .append('svg')
      .attr("width", width)
      .attr("height", height)
      .attr("viewBox", [0, 0, width, height])
      .attr("style", "max-width: 100%; height: auto; height: intrinsic;")
      .style("-webkit-tap-highlight-color", "transparent")
      .append("g")
      .attr("transform",
        "translate(" + margin.left + "," + margin.top + ")");

    this.svg.append("g")
      .attr("transform", "translate(0," + compHeight + ")")
      .call(d3.axisBottom(x))
      .selectAll("text")
      .style("text-anchor", "end")
      .attr("dx", "-.8em")
      .attr("dy", ".15em")
      .attr("transform", "rotate(-65)")
      .call(g => g.select(".domain").remove());

    this.svg.append("path")
      .attr("class", "mypath")
      .datum(density)
      .attr("fill", color)
      .attr("opacity", ".8")
      .attr("stroke", "#fff")
      .attr("stroke-width", 1)
      .attr("stroke-linejoin", "round")
      .attr("d",  d3.line()
        .curve(d3.curveBasis)
          .x(function(d) { return x(d[0]); })
          .y(function(d) { return y(d[1]); })
      );

    if (!isNaN(vert)) {
      var percText =  Math.round(perc * 100).toString() + "th perc."
      this.svg.append("line")
        .attr("y1", 0)
        .attr("y2", compHeight)
        .attr("x1", x(vert))
        .attr("x2", x(vert))
        .style("stroke-width", 2)
        .style("stroke", "black")
        .style("fill", "none");

      if (x(vert) > (width / 2)) {
        this.svg.append("text")
          .attr("x", x(vert) - 30)
          .attr("y", 15)
          .text(percText)
          .style("font-weight", "bold")
          .style("font-size", "12pt")
      } else {
        this.svg.append("text")
          .attr("x", x(vert) + 5)
          .attr("y", 15)
          .text(percText)
          .style("font-weight", "bold")
          .style("font-size", "12pt")
      }
    }

  }

  // This is what I need to compute kernel density estimation
  kernelDensityEstimator(kernel: any, X: any) {
    return function (V) {
      return X.map(function (x) {
        return [x, d3.mean(V, function (v: any) { return kernel(x - v); })];
      });
    };
  }

  kernelEpanechnikov(k) {
    return function (v) {
      return Math.abs(v /= k) <= 1 ? 0.75 * (1 - v * v) / k : 0;
    };
  }



}
